import React from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  animation?: 'fade-in' | 'slide-in-up' | 'scale-in';
}

const ScrollReveal: React.FC<ScrollRevealProps> = ({ 
  children, 
  className = '', 
  delay = 0,
  animation = 'fade-in'
}) => {
  const { elementRef, isVisible } = useScrollAnimation();

  const animationClasses = {
    'fade-in': 'animate-fade-in',
    'slide-in-up': 'animate-fade-in',
    'scale-in': 'animate-scale-in'
  };

  return (
    <div
      ref={elementRef}
      className={`transition-all duration-700 ${
        isVisible 
          ? `${animationClasses[animation]} opacity-100 translate-y-0` 
          : 'opacity-0 translate-y-8'
      } ${className}`}
      style={{ 
        transitionDelay: isVisible ? `${delay}ms` : '0ms'
      }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;